// General
import './header/aside-menu';

// WooCommerce
import './woocommerce/product-archive';
import './woocommerce/product-tabs';
